export default __webpack_public_path__ + "static/media/bell_red.98b9df53.gif";